module.exports = __webpack_public_path__ + "media/images/lb/617-e733122a686430b4e119e5366b6e57ce.svg";